import React from "react";
import LoadDocumentCmp from "../../../../components/thumbnail/loadDocumentCmp";
import { Grid } from "@mui/material";

export default function IdntityCard(props: any) {
  return (
    <div className="identityCardDesign ">
      <div>
        <div
          style={{
            marginTop: "30px",
            marginRight: "30px",
            marginBottom: "30px",
          }}
        >
          <img
            src={props.iconAddress}
            style={{ fontSize: "25px", marginLeft: "5px" }}
          />

          <span
            className="colorTitle fontTitle"
            style={{ fontWeight: "bold", fontSize: "16px" }}
          >
            {props.title}
          </span>
        </div>
        <Grid
          container
          className="dropzoneSet"
          columns={{ xs: 4, sm: 8, md: 12 }}
          style={{ marginRight: "-2vh" }}
        >
          {props.data?.map((item: any) => (
            <Grid item xs={4} className="classCenter">
              <LoadDocumentCmp data={item} title={true} />
            </Grid>
          ))}
        </Grid>
      </div>
    </div>
  );
}
